import { handleClickCard } from "../../../../functions/functions";
import "./headerCardListSponsored.sass";

/**
 * Renderiza los momios disponibles en el header de un evento patrocinado.
 */
export default function HeaderCardListSponsored({ patrocinador, item }) {
  if (!item || typeof item !== "object") return null;

  const patrocinadorKey = patrocinador?.toLowerCase().trim() || "";
  // Obtiene el objeto metadata específico del patrocinador
  const patrocinadorMetadata = item?.[`${patrocinadorKey}_metadata`] || {};
  // Define las posiciones donde se colocan los momios
  const positions = ["left", "middle", "right"];

  return (
    <a href={item.opta_event_url} target="_parent" rel="noreferrer" className="card-list-sponsored__header">
      {positions.map((position) => {
        const url = patrocinadorMetadata?.[`${position}_url_mm`] || "";
        const label = patrocinadorMetadata?.[`${position}_mm`] || "";
        const isClickable = typeof url === "string" && url.trim().length > 0;

        return isClickable ? (
          <button
            type="button"
            key={position}
            onClick={(e)=>handleClickCard(e, url)}
            title={url} // mostrarlo como tooltip
            className="card-list-sponsored__header-momio"
          >
            {label}
          </button>
        ) : (
          <p key={position} className="card-list-sponsored__header-sin-momio">{label}</p>
        );
      })}
    </a>
  );
}